import { http } from '@/api/client/httpClient';
import type { ExpectedEodSwapSnapshotDto, NopFiltersDto } from '@/api/types/riskDashboard';

// Expected EOD Swap. The running backend exposes GetCalculatedAsync(Guid? tenantId, …)
// as /calculated/{tenantId?} — the nullable path param is optional, so omitting it
// resolves to the current tenant (the __tenant header the http client already sends).
const EOD = '/api/app/expected-eod-swap';

export const consolidatedExposureApi = {
  async getExpectedEodSwap(tenantId: string | null, filters: NopFiltersDto): Promise<ExpectedEodSwapSnapshotDto> {
    // Route is /calculated/{tenantId}; pass the current tenant GUID from app-config.
    const { data } = await http.get<ExpectedEodSwapSnapshotDto>(`${EOD}/calculated/${tenantId ?? ''}`, { params: filters });
    return data;
  },
  // Excel export replays the per-user cached snapshot from the last fetch.
  exportUrl: (tenantId: string | null) => `${EOD}/export/${tenantId ?? ''}`,
};
